import { render, staticRenderFns } from "./ImportLbDemand.vue?vue&type=template&id=b986464c&scoped=true"
import script from "./ImportLbDemand.vue?vue&type=script&lang=js"
export * from "./ImportLbDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b986464c",
  null
  
)

export default component.exports